import {
  AfterViewInit,
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { ExtendDataTable, isExtendedDataTable } from '@qtek/libs/collections';
import { isNullable } from '@qtek/shared/utils';

@Directive({
  selector: '[qtGroupRow]',
  standalone: false,
})
export class GroupRowDirective<T> implements AfterViewInit {
  private viewContainerRef = inject(ViewContainerRef);

  /** Row data. */
  @Input('qtGroupRow') row: T & ExtendDataTable;

  /** Hidden row template. */
  @Input('qtGroupRowTemplate') template: TemplateRef<any>;

  /** Whether view should be shown or not. */
  @Input('qtGroupRowShow')
  set show(value: boolean) {
    this.value = value;

    if (isNullable(this.template)) {
      return;
    }

    this.changeGroupRowShow(value);
  }

  private value = false;

  ngAfterViewInit() {
    this.changeGroupRowShow(this.value);
  }

  private changeGroupRowShow(value: boolean): void {
    if (
      value &&
      isExtendedDataTable(this.row) &&
      (this.row as any).__orderInGroup === 0
    ) {
      const viewRef = this.viewContainerRef.createEmbeddedView(
        this.template,
        {
          $implicit: this.row,
        },
        {
          index: 0,
        }
      );
      viewRef.detectChanges();
    } else {
      this.viewContainerRef.clear();
    }
  }
}
